/*
  F&NT · Animación del recuadro «Tus beneficios» del carrito (v25, 15 oct 2026; pedido por Diego el 15 oct).
  - Al abrir el carrito, cada barra se llena de izquierda a derecha.
  - Al agregar, quitar o cambiar cantidad, Shopify vuelve a dibujar el carrito completo: la barra nueva arranca
    donde estaba la anterior y avanza (o retrocede) hasta su nuevo valor.
  - Cuando un renglón pasa de barra a check (llegó a la meta), el check entra con un pequeño rebote;
    un renglón que no estaba (p. ej. créditos) aparece con un fundido.
  - Con «reducir movimiento» del sistema no anima nada.
  Cada renglón trae data-fnt-row (regalo, shaker, envio, creditos…) desde snippets/fnt-carrito-beneficios.liquid,
  que también carga este archivo. Estilos de la animación: assets/fnt-carrito.css.
*/
(function () {
  if (window.__fntCarritoAnim) return;
  window.__fntCarritoAnim = true;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var antes = {};      // renglón → % de su barra (o 100 si ya tenía check)
  var habia = null;    // renglones del último dibujo (null = todavía no hay referencia)

  function pct(i) { return parseFloat(i.getAttribute('data-fnt-meta') || i.style.width) || 0; }

  function mover(i, desde, hasta, espera) {
    i.setAttribute('data-fnt-meta', hasta);
    i.style.transition = 'none';
    i.style.width = desde + '%';
    void i.offsetWidth;
    i.style.transition = '';
    setTimeout(function () { i.style.width = hasta + '%'; }, espera || 30);
  }

  function leer(caja) {
    var r = {};
    caja.querySelectorAll('[data-fnt-row]').forEach(function (fila) {
      var i = fila.querySelector('.fnt-ben__bar i');
      r[fila.getAttribute('data-fnt-row')] = i ? pct(i) : (fila.querySelector('.fnt-ben__ok') ? 100 : -1);
    });
    return r;
  }

  // Carrito nuevo después de un cambio: lo nuevo (sin marca) parte de donde estaba
  function revisar() {
    var caja = document.querySelector('.fnt-ben');
    if (!caja) return;
    var abierto = !!caja.closest('dialog[open]');
    caja.querySelectorAll('[data-fnt-row]').forEach(function (fila) {
      if (fila.hasAttribute('data-fnt-visto')) return;
      fila.setAttribute('data-fnt-visto', '');
      var k = fila.getAttribute('data-fnt-row');
      var i = fila.querySelector('.fnt-ben__bar i');
      var ok = fila.querySelector('.fnt-ben__ok');
      if (!abierto || habia === null) { if (i) i.setAttribute('data-fnt-meta', pct(i)); return; }
      if (!(k in habia)) fila.classList.add('fnt-ben__row--entra');
      if (i) mover(i, k in antes && antes[k] >= 0 && antes[k] < 100 ? antes[k] : 0, pct(i));
      else if (ok && k in antes && antes[k] < 100) ok.classList.add('fnt-ben__ok--pop');
    });
    habia = leer(caja);
    antes = habia;
  }
  var pendiente = false;
  function programar() {
    if (pendiente) return;
    pendiente = true;
    requestAnimationFrame(function () { pendiente = false; revisar(); });
  }

  // Al abrir el carrito: las barras se llenan desde cero
  function alAbrir(dialogo) {
    var caja = dialogo.querySelector('.fnt-ben');
    if (!caja) return;
    caja.querySelectorAll('[data-fnt-row]').forEach(function (f) { f.setAttribute('data-fnt-visto', ''); });
    caja.querySelectorAll('.fnt-ben__bar i').forEach(function (i) { mover(i, 0, pct(i), 260); });
    habia = leer(caja);
    antes = habia;
  }

  function inicio() {
    var caja = document.querySelector('.fnt-ben');
    if (caja) {
      caja.querySelectorAll('[data-fnt-row]').forEach(function (f) { f.setAttribute('data-fnt-visto', ''); });
      caja.querySelectorAll('.fnt-ben__bar i').forEach(function (i) { i.setAttribute('data-fnt-meta', pct(i)); });
      habia = leer(caja);
      antes = habia;
    }
    new MutationObserver(function (ms) {
      for (var n = 0; n < ms.length; n++) {
        var m = ms[n];
        if (m.type === 'attributes') {
          if (m.target.matches && m.target.matches('dialog.cart-drawer__dialog') && m.target.hasAttribute('open') && m.oldValue === null) alAbrir(m.target);
          continue;
        }
        if (m.addedNodes.length) programar();
      }
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open'], attributeOldValue: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inicio);
  else inicio();
})();
